import React, { useCallback, useEffect, useState } from "react";
import Header from "../../assets/components/header";
import Footer from "../../assets/components/footer";
import ReportDashboardPage from "../../assets/components/reports/ReportDashboardPage";
import Report from "../../models/Report";

function EntitiesDashboard({ history, user }) {
    const [filters, setFilters] = useState({});
    const fetchDashboardManifest = useCallback((params, signal) => {
        return Report.dashboardManifest("entities", params, signal);
    }, []);
    const fetchDashboardBatch = useCallback((params, reportBatch, signal) => {
        return Report.dashboardBatch("entities", params, reportBatch, signal);
    }, []);

    useEffect(() => {
        if (user.has("MASHIE_ADMIN") === false) {
            history.push("/members/list");
        }
    }, [history, user]);

    if (user.has("MASHIE_ADMIN") === false) {
        return null;
    }

    return (
        <>
            <div className='d-flex main'>
                <Header history={history} />
                <ReportDashboardPage
                    title='Entities Dashboard'
                    subtitle='Entity-level reporting aligned to the default entity membership period.'
                    fetchDashboardManifest={fetchDashboardManifest}
                    fetchDashboardBatch={fetchDashboardBatch}
                    filters={filters}
                    onFiltersChange={setFilters}
                />
            </div>
            <Footer />
        </>
    );
}

export default EntitiesDashboard;
